module.exports = "/_next/static/images/43e5cb1df8d017c4036f5c0471182272-cuenta-zero-rate.svg";